import React from 'react';
import PropTypes from 'prop-types';
import { Translation } from '../../common';

const RecommendHelpHeader = ({ styles }) => (
  <div className={styles['recommend-help-header__wrapper']}>
    <div className={styles['recommend-help-header__header']}>
      <Translation>CALCULATOR_HEADER</Translation>
    </div>
    <div className={styles['recommend-help-header__description']}>
      <Translation>CALCULATOR</Translation>
    </div>
  </div>
);

RecommendHelpHeader.propTypes = {
  styles: PropTypes.object
};

export default RecommendHelpHeader;
